import React from 'react';
import { theme, buttonStyles } from '../styles';
import { personalInfo } from '../data';

const HomePage = ({ isMobile }) => {
  return (
    <section style={{
      ...styles.hero,
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      padding: isMobile ? '2rem 1rem' : '4rem 2rem',
      gap: isMobile ? '2rem' : '4rem',
      minHeight: isMobile ? 'auto' : 'calc(100vh - 80px)',
    }}>
      {/* Content */}
      <div style={styles.heroContent}>
        <div style={styles.greeting}>Bonjour, je suis</div>
        <h1 style={{
          ...styles.heroTitle,
          fontSize: isMobile ? '2rem' : 'clamp(2.5rem, 5vw, 4rem)',
        }}>
          {personalInfo.name}
        </h1>
        <h2 style={{
          ...styles.heroSubtitle,
          fontSize: isMobile ? '1.1rem' : 'clamp(1.25rem, 2.5vw, 1.75rem)',
        }}>
          {personalInfo.role}
        </h2>
        <p style={{
          ...styles.heroDescription,
          fontSize: isMobile ? '0.95rem' : '1.1rem',
        }}>
          {personalInfo.shortBio}
        </p>
        
        {/* Stats */}
        <div style={{
          ...styles.heroStats,
          gap: isMobile ? '1.5rem' : '2rem',
          justifyContent: isMobile ? 'space-around' : 'flex-start',
        }}>
          <div style={styles.stat}>
            <span style={{
              ...styles.statNumber,
              fontSize: isMobile ? '1.5rem' : '2rem',
            }}>{personalInfo.age}</span>
            <span style={styles.statLabel}>ans</span>
          </div>
          <div style={styles.stat}>
            <span style={{
              ...styles.statNumber,
              fontSize: isMobile ? '1.5rem' : '2rem',
            }}>{personalInfo.stats.yearsExperience}</span>
            <span style={styles.statLabel}>ans d'exp.</span>
          </div>
          <div style={styles.stat}>
            <span style={{
              ...styles.statNumber,
              fontSize: isMobile ? '1.5rem' : '2rem',
            }}>{personalInfo.stats.languages}</span>
            <span style={styles.statLabel}>langages</span>
          </div>
        </div>
        
        {/* CTA Buttons */}
        <div style={{
          ...styles.heroCta,
          flexDirection: isMobile ? 'column' : 'row',
        }}>
          <a 
            href={`mailto:${personalInfo.email}`} 
            style={{
              ...styles.primaryButton,
              textAlign: 'center',
              padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem',
            }}
          >
            Me Contacter
          </a>
          <a 
            href={personalInfo.social.github}
            target="_blank" 
            rel="noopener noreferrer" 
            style={{
              ...styles.secondaryButton,
              textAlign: 'center',
              padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem',
            }}
          >
            Voir GitHub
          </a>
        </div>
      </div>
      
      {/* Code Block Visual */}
      <div style={{
        ...styles.heroVisual,
        display: isMobile ? 'block' : 'block',
      }}>
        <div style={styles.codeBlock}>
          <div style={styles.codeHeader}>
            <span style={styles.codeDot} />
            <span style={{...styles.codeDot, background: '#FEBC2E'}} />
            <span style={{...styles.codeDot, background: '#28C840'}} />
          </div>
          <pre style={{
            ...styles.codeContent,
            fontSize: isMobile ? '0.7rem' : '0.85rem',
            padding: isMobile ? '1rem' : '1.5rem',
          }}>
{isMobile ? `const dev = {
  name: "${personalInfo.name}",
  skills: ["PHP", "React", 
           "Flutter", "SQL"]
};` : `const developer = {
  name: "${personalInfo.name}",
  role: "${personalInfo.role}",
  skills: [
    "PHP/Laravel",
    "React/Vue.js",
    "Flutter",
    "SQL"
  ],
  passion: "La technologie"
};

developer.code();`}
          </pre>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    alignItems: 'center',
  },
  heroContent: {
    animation: 'fadeInUp 0.6s ease',
  },
  greeting: {
    color: theme.colors.primary,
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '0.5rem',
    fontFamily: theme.fonts.mono,
  },
  heroTitle: {
    fontWeight: '700',
    marginBottom: '0.5rem',
    background: `linear-gradient(135deg, ${theme.colors.text} 0%, ${theme.colors.textMuted} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    lineHeight: 1.1,
  },
  heroSubtitle: {
    fontWeight: '500',
    color: theme.colors.primary,
    marginBottom: '1.5rem',
  },
  heroDescription: {
    lineHeight: '1.7',
    color: theme.colors.textMuted,
    marginBottom: '2rem',
    maxWidth: '500px',
  },
  heroStats: {
    display: 'flex',
    marginBottom: '2rem',
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  statNumber: {
    fontWeight: '700',
    color: theme.colors.primary,
    fontFamily: theme.fonts.mono,
  },
  statLabel: {
    fontSize: '0.8rem',
    color: theme.colors.textDark,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  heroCta: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap',
  },
  primaryButton: {
    ...buttonStyles.primary,
  },
  secondaryButton: {
    ...buttonStyles.secondary,
  },
  heroVisual: {
    animation: 'fadeInUp 0.6s ease 0.2s backwards',
  },
  codeBlock: {
    background: theme.colors.backgroundAlt,
    borderRadius: '16px',
    overflow: 'hidden',
    border: '1px solid rgba(0, 217, 255, 0.2)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
  },
  codeHeader: {
    background: '#252a3d',
    padding: '0.75rem 1rem',
    display: 'flex',
    gap: '8px',
  },
  codeDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: '#FF605C',
  },
  codeContent: {
    fontFamily: theme.fonts.mono,
    lineHeight: '1.8',
    color: theme.colors.textMuted,
    margin: 0,
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
};

export default HomePage;
